import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tabla de registros", -1)
const _hoisted_4 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-30px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-120px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-40px" })
  ])
], -1)
const _hoisted_12 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-muted fw-bold" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_18 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown3 = _resolveComponent("Dropdown3")
  const _component_spam = _resolveComponent("spam")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h3", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, "contiene " + _toDisplayString(_ctx.numregisters.length) + " registros", 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", _hoisted_6, [
          _createVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown3)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("table", _hoisted_10, [
          _hoisted_11,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.numregisters, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode(_component_spam, { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createVNode("td", null, [
                  _createVNode(_component_spam, { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.description.split('[')[0]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode("span", _hoisted_12, _toDisplayString(item.description.split("[")[1].split("]")[0]), 1)
                ]),
                _createVNode("td", _hoisted_13, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList((item.description.split('[')[1].split(']')[0]).split('/'), (item1, index1) => {
                    return (_openBlock(), _createBlock(_component_spam, {
                      key: index1,
                      class: "badge fw-bold me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item1), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _createVNode("td", _hoisted_14, [
                  _createVNode("span", _hoisted_15, _toDisplayString(item.metric), 1)
                ]),
                _createVNode("td", _hoisted_16, [
                  _createVNode("a", _hoisted_17, [
                    _createVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/Edit.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}